<template>
  <v-container id="club-alta" fluid>
        <v-dialog v-model="show" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Nuevo club</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <validation-observer v-slot="{ handleSubmit }">
              <form id="altaclub" @submit.prevent="handleSubmit(validateForm)">
                <v-row align="center" justify="center">
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" name="club" rules="max:20">
                      <v-text-field v-model="club.descripcion" color="#ac8a2e" :error-messages="errors" name="input-6-1" label="Club" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" name="liga" rules="required">
                      <v-select v-model="club.liga_id" color="#ac8a2e" :error-messages="errors" label="Liga" item-value="id" item-text="descripcion" :items="ligas">
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="secondary elevation-4 white--text" class="v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.descripcion" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                </v-row>
              </form>
            </validation-observer>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text form="altaclub" type="submit">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        required: false,
        default: 'new',
      },
      show: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    data () {
      return {
        ligas: [],
        club: {},
      }
    },
    created () {
      this.getLigas()
    },
    methods: {
      getLigas () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/liga_get' }).then(response => { this.ligas = response })
      },
      setClub () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/club_get/' + this.club.descripcion + '/' + this.club.liga_id }).then(response => { this.clubSelected = response.id })
      },
      close () {
        this.club = {}
        this.$emit('close')
      },
      validateForm (scope) {
        this.enviarClub()
      },
      enviarClub: async function () {
        const method = 'post'
        await this.$http({
          method: method,
          url: '/api/club_agregar',
          data: {
            ...this.club,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de club exitosa'] })
          /* this.getClubes() */
          this.$emit('close-dialog', response.data)
          this.close()
          console.log(response.data)
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
      },
    },
  }
</script>
